const initialState = {
  data: [],
  fetching: false,
  hasMore: true,
  fetched: false,
  error: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'REVIEWS_FETCH_PENDING':
      return {
        ...state,
        fetching: true,
      }

    case 'REVIEWS_FETCH_REJECTED':
      return {
        ...state,
        fetching: false,
        error: true,
      }

    case 'REVIEWS_FETCH_FULFILLED':
      return {
        ...state,
        fetching: false,
        fetched: true,
        hasMore: action.payload.data.has_more,
        data: state.data.concat(action.payload.data.results),
      }

    case 'LISTING_FETCH_FULFILLED':
      return {
        ...state,
        ...action.payload.data.reviews,
      }

    default:
      return state
  }
}
